import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {ContactComponent} from "./contact.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/contact', {template: ''});
    }]);
/***/

const sampleRoutes: Routes = [
    {path: 'company/:id/contact', component: ContactComponent},
    {path: 'cars-sara-v2/web/company/:id/contact', component: ContactComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(sampleRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class ContactRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/contact/contact-routing.module.ts